import { render, staticRenderFns } from "./BillerTerms.vue?vue&type=template&id=4ffa59b8&scoped=true"
import script from "./BillerTerms.vue?vue&type=script&lang=js"
export * from "./BillerTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffa59b8",
  null
  
)

export default component.exports